import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Scrollbars } from 'react-custom-scrollbars';

import style from './index.scss';
import { nsColorFinder } from '../../util';

class FigureHeatmap extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    columns: PropTypes.array.isRequired,
    data: PropTypes.object.isRequired,
    fillColor: PropTypes.string,
    tableFilter: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.state = {
      prevLeft: -1,
      prevTop: -1,
      toLeft: 0,
      tableWidth: '100%',
      expandIndex: 1
    };
  }

  componentDidMount() {
    this.updateTableWidth();

    try {
      window.addEventListener('resize', this.updateTableWidth.bind(this));
    } catch (e) {
      return;
    }
  }

  componentWillUnmount() {
    try {
      window.removeEventListener('resize', this.updateTableWidth.bind(this));
    } catch (e) {
      return;
    }
  }

  getHeatGrade = (val, highest, lowest) => {
    if (highest === 0) return 0;

    return ((val - lowest) / (highest - lowest)).toFixed(1);
  };

  handleScroll = (e) => {
    const { prevTop } = this.state;

    if (prevTop === e.top) {
      this.setState({
        ...this.state,
        prevLeft: e.left,
        prevTop: e.top,
        toLeft: e.scrollLeft
      });
    } else {
      this.setState({
        ...this.state,
        prevLeft: e.left,
        prevTop: e.top
      });
    }
  };

  toExpandRow = (index) => {
    this.setState({
      expandIndex: index
    });
  };

  //very important:
  // to update table and thead's width to make scrollbar shown for Scrollbars 3rd party api
  updateTableWidth = () => {
    try {
      const newWidth = window.innerWidth - 200;
      this.setState({
        ...this.state,
        tableWidth: `${newWidth}px`
      });
    } catch (e) {
      return;
    }
  };

  render() {
    const { toLeft, tableWidth, expandIndex } = this.state;
    const { name, columns, data, fillColor, tableFilter } = this.props;

    if (!columns || !data) {
      return <div>Heatmap is waiting for data</div>;
    }

    const metadata = data.metadata || {};
    const tableData = data.data || [];

    let headers = [];
    let subheaders = [];
    columns.forEach((col, i) => {
      if (!tableFilter[name] || tableFilter[name][col.id]) {
        //check whether filter is on
        const color = nsColorFinder(col.id);
        headers.push(
          <th key={`header-${i}`}>
            <i
              className={classnames(style.dotIndicator)}
              style={{ background: color }}></i>
            {col.name}
          </th>
        );
        if (metadata[col.id]) {
          subheaders.push(
            <th key={`subheader-${i}`}>{metadata[col.id]['total']}</th>
          );
        }
      }
    });

    let dataInRows = [];
    tableData.forEach((row, i) => {
      /*
       skip the "All Segments" data
      */

      let firstCol = (
        <td key={`row-${row.id}`} style={{ left: toLeft + 'px' }}>
          {row.name}
          {expandIndex === i ? (
            <div className={style.prevData}>Previous Data</div>
          ) : null}
        </td>
      );

      let restCols = [];
      row.data.all &&
        row.data.all.forEach((cell, j) => {
          if (!tableFilter[name] || tableFilter[name][cell.id]) {
            let highest = 0;
            let lowest = 0;
            if (metadata[cell.id]) {
              highest = metadata[cell.id]['highest'] || 0;
              lowest = metadata[cell.id]['lowest'] || 0;
            }
            /* {expandIndex == i? <div className={style.prevData} style={{left: toLeft + "px"}}>
              <span className={style.prevDataValue}>{cell.preValue}</span> &nbsp;
              <small>
                <i className={classnames("fa", cell.value > cell.preValue ? 'fa-caret-up' : 'fa-caret-down')}></i>
                <span>{toPercetage(cell.value, cell.preValue)}</span>
              </small>
            </div> : null} */
            restCols.push(
              <td
                key={`cell-${i}-${j}`}
                style={{
                  background: hex2rgb(
                    fillColor,
                    this.getHeatGrade(cell.value, highest, lowest)
                  )
                }}>
                {cell.value}
              </td>
            );
          }
        });

      dataInRows.push(
        <tr
          key={`row-${i}`}
          onClick={() => {
            this.toExpandRow(i);
          }}>
          {firstCol}
          {restCols}
        </tr>
      );
    });

    return (
      <table className={style.wrapper} style={{ width: tableWidth }}>
        <thead style={{ left: -toLeft + 'px', width: tableWidth }}>
          <tr>
            <th style={{ left: toLeft + 'px' }}></th>
            {headers}
          </tr>
          <tr>
            <th style={{ left: toLeft + 'px' }}></th>
            {subheaders}
          </tr>
        </thead>
        <Scrollbars style={{ height: 420 }} onScrollFrame={this.handleScroll}>
          <tbody>{dataInRows}</tbody>
        </Scrollbars>
      </table>
    );
  }
}

const hex2rgb = (hex, opacity) => {
  hex = hex.trim();
  hex = hex[0] === '#' ? hex.substr(1) : hex;
  var bigint = parseInt(hex, 16),
    h = [];
  if (hex.length === 3) {
    h.push((bigint >> 4) & 255);
    h.push((bigint >> 2) & 255);
  } else {
    h.push((bigint >> 16) & 255);
    h.push((bigint >> 8) & 255);
  }
  h.push(bigint & 255);
  if (opacity) {
    h.push(opacity);
    return 'rgba(' + h.join() + ')';
  } else {
    return 'rgb(' + h.join() + ')';
  }
};

const toPercetage = (cur, pre) => {
  let perc = (Math.abs(cur - pre) / pre).toFixed(2);
  return `${perc}%`;
};

export default FigureHeatmap;
